// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"25438fff","455":"e5128044","977":"7e0a9981"}[chunkId] + ".chunk.js";
};